import * as React from 'react'
import { Heading, HStack, StackProps, VStack } from '@chakra-ui/react'
import { Dropdown } from '@/app/components/common/Dropdown'
import { AllowedSizes } from '@/core/real-estate/typings'
import { formatNumber } from '@/utils/format-number'

interface SizePickerProps extends StackProps {
  minValue: keyof typeof AllowedSizes
  maxValue: keyof typeof AllowedSizes
  onMinChange: (value: keyof typeof AllowedSizes) => void
  onMaxChange: (value: keyof typeof AllowedSizes) => void
  disableAll?: boolean
  title?: string
}

const SizePicker: React.FC<SizePickerProps> = ({
  title,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  disableAll,
  ...props
}) => {
  return (
    <VStack w="full" {...props}>
      {title ? (
        <Heading w="full" as="h6" fontSize="lg">
          {title}
        </Heading>
      ) : null}
      <HStack w="full" spacing="3">
        <Dropdown
          isDisabled={disableAll}
          value={minValue}
          formatOption={(_key, value) => {
            const formattedNumber = formatNumber(parseInt(value))
            if (formattedNumber !== '0') {
              return `${formattedNumber} m2`
            } else {
              return 's/min'
            }
          }}
          flex={0.5}
          placeholder="min"
          enum={AllowedSizes}
          onOptionSelection={(e) => {
            if (e) {
              onMinChange(e)
            }
          }}
        />

        <Dropdown
          isDisabled={disableAll}
          value={maxValue}
          formatOption={(_key, value) => {
            const formattedNumber = formatNumber(parseInt(value))
            if (formattedNumber !== '0') {
              return `${formattedNumber} m2`
            } else {
              return 's/max'
            }
          }}
          flex={0.5}
          placeholder="max"
          enum={AllowedSizes}
          onOptionSelection={(e) => {
            if (e) {
              onMaxChange(e)
            }
          }}
        />
      </HStack>
    </VStack>
  )
}

export default SizePicker
